"use client";

import { MobileSidebar as UiMobileSidebar } from "@kkeut/ui/mobile-sidebar";
import { useMobileSidebarState } from "@/store/MobileSidebarState";
import { useLocale } from "@/components/LocaleProvider";
import { labelOf, isActiveForLocale, withLocaleHref } from '@/lib/locale';

export default function MobileSidebar({ initialMenuItems = null }) {
  const sidebarState = useMobileSidebarState();
  const { locale } = useLocale();
  return (
    <UiMobileSidebar
      initialMenuItems={initialMenuItems}
      branchId="guro"
      sidebarState={sidebarState}
      locale={locale}
      withLocaleHref={withLocaleHref}
      labelOf={labelOf}
      isActiveForLocale={isActiveForLocale}
    />
  );
}
